var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"il-wrapper"},[_c('header-banner'),_c('div',{staticClass:"il-container"},[_c('navigation',{attrs:{"color":'lightGrey'}}),_c('teams-cards')],1),_c('footer-info',{attrs:{"color":'lightGrey'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }